export const API_BASE_URL = `${process.env.REACT_APP_API_URL_USER_DATA}/payments`;
export const API_BASE_URL_RETRAITS = `${process.env.REACT_APP_API_URL_RESSOURCES}/retraits`;
